import React from 'react';
import { Dispatch } from 'redux';
import { connect } from 'react-redux';
import { setVetHospitalModalVisibleAction } from 'redux/actions/modal.action';
import { RootReducersState } from 'redux/reducers';
import Modal from 'components/Modal';
import { IProps } from './types';

const VetHospital: React.FC<IProps> = (props) => {
  const handleConfirm = () => {
    props.setVetHospitalModalVisible(false);
  };

  const handleCancel = () => {
    props.setVetHospitalModalVisible(false);
    props.handleVetHospitalMapCancel();
  };

  return (
    <>
      {props.modal.vetHospitalModalVisible && (
        <div className="vet-hospital-modal">
          <Modal
            visible={props.modal.vetHospitalModalVisible}
            title="指定獸醫院清單"
            cancelButton
            closeIcon={false}
            confirmButtonText="已閱覽並同意"
            onConfirm={handleConfirm}
            cancelButtonText="不同意"
            onCancel={handleCancel}
          >
            <div className="vet-hospital-map-container">
              <iframe src="https://petscare.ai/Healthy/VetHospital/" title="map" />
            </div>
            <p>
              <span className="red">本人已閱覽</span>旺旺友聯產險<span className="red">指定獸醫院清單</span>，
              並<span className="red">已知悉</span>被保險寵物之診療行為或發生急重症時應送往之<span className="red">指定獸醫院。</span>
              <span className="red">(提醒：指定獸醫院清單會不定期更新，就診前請詳官網指定獸醫院清單連結確認)</span>
            </p>
          </Modal>
        </div>
      )}
    </>
  );
};

const mapStateToProps = (state: RootReducersState) => ({
  modal: state.modal
});

const mapDispatchToProps = (dispatch: Dispatch) => ({
  setVetHospitalModalVisible: (visible: boolean) => dispatch(setVetHospitalModalVisibleAction(visible))
});

export default connect(mapStateToProps, mapDispatchToProps)(VetHospital);
